import TransactionsActionTypes from './transactions-types'

const INITIAL_STATE = {
    recentTransactions: null,
    filteredTransactions: null,
    loader: null,
    success: null,
    successMsg: null,
    loadingAlert: null,
    alertTransaction: null,
    payTransaction: null,
    pdfDownload: null,
    pdfStatement: null,
    textStatement: null,
    xmlStatement: null,
    csvStatement: null,
    files: null,
    counts: null,
    statuses: null,
}

const transactionsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TransactionsActionTypes.START_TRANSACTIONS:
            return {
                ...state,
                loader: { ...state.loader, LATEST_TRANSACTIONS: true },
            }
        case TransactionsActionTypes.SUCCESS_TRANSACTIONS:
            return {
                ...state,
                recentTransactions: action.payload,
                loader: { ...state.loader, LATEST_TRANSACTIONS: null },
            }

        case TransactionsActionTypes.START_FILTERING_TRANSACTIONS:
            return {
                ...state,
                loader: { ...state.loader, FILTERING_TRANSACTIONS: true },
            }

        case TransactionsActionTypes.START_ALERT_TRANSACTION:
            return {
                ...state,
                loadingAlert: true,
            }
        case TransactionsActionTypes.FETCH_PAY_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, PAY_TRANSACTION: true },
            }
        case TransactionsActionTypes.SUCCESS_PAY_TRANSACTION:
            return {
                ...state,
                payTransaction: action.payload,
                loader: { ...state.loader, PAY_TRANSACTION: null },
                successMsg: 'completed',
            }
        case TransactionsActionTypes.FINISH_PAY_TRANSACTION:
            return {
                ...state,
                payTransaction: null,
                loader: { ...state.loader, PAY_TRANSACTION: null },
                successMsg: null,
            }
        case TransactionsActionTypes.SUCCESS_FILTERING_TRANSACTIONS:
            return {
                ...state,
                filteredTransactions: action.payload,
                loader: { ...state.loader, FILTERING_TRANSACTIONS: false },
            }
        case TransactionsActionTypes.SUCCESS_ALERT_TRANSACTION:
            return {
                ...state,
                alertTransaction: action.payload,
                loadingAlert: null,
            }

        case TransactionsActionTypes.START_PUT_TRANSACTION_NOTE:
            return {
                ...state,
                loader: { ...state.loader, PUT_TRANSACTION_NOTE: true },
            }
        case TransactionsActionTypes.SUCCESS_PUT_TRANSACTION_NOTE:
            return {
                ...state,
                loader: { ...state.loader, PUT_TRANSACTION_NOTE: null },
                success: { ...state.success, PUT_TRANSACTION_NOTE: true },
                successMsg: 'note changed',
            }
        case TransactionsActionTypes.FINISH_PUT_TRANSACTION_NOTE:
            return {
                ...state,
                loader: { ...state.loader, PUT_TRANSACTION_NOTE: null },
                success: { ...state.success, PUT_TRANSACTION_NOTE: null },
                successMsg: null,
            }
        case TransactionsActionTypes.ERROR_PUT_TRANSACTION_NOTE:
            return {
                ...state,
                loader: { ...state.loader, PUT_TRANSACTION_NOTE: null },
                success: { ...state.success, PUT_TRANSACTION_NOTE: null },
                successMsg: null,
            }

        case TransactionsActionTypes.START_CANCEL_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, CANCEL_TRANSACTION: true },
            }
        case TransactionsActionTypes.SUCCESS_CANCEL_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, CANCEL_TRANSACTION: null },
                success: { ...state.success, CANCEL_TRANSACTION: true },
                successMsg: 'canceled',
            }
        case TransactionsActionTypes.FINISH_CANCEL_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, CANCEL_TRANSACTION: null },
                success: { ...state.success, CANCEL_TRANSACTION: null },
                successMsg: null,
            }
        case TransactionsActionTypes.ERROR_CANCEL_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, CANCEL_TRANSACTION: null },
                success: { ...state.success, CANCEL_TRANSACTION: null },
                successMsg: null,
            }

        case TransactionsActionTypes.START_COMPLETE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, COMPLETE_TRANSACTION: true },
            }
        case TransactionsActionTypes.SUCCESS_COMPLETE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, COMPLETE_TRANSACTION: null },
                success: { ...state.success, COMPLETE_TRANSACTION: true },
                successMsg: 'completed',
            }
        case TransactionsActionTypes.FINISH_COMPLETE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, COMPLETE_TRANSACTION: null },
                success: { ...state.success, COMPLETE_TRANSACTION: null },
                successMsg: null,
            }
        case TransactionsActionTypes.ERROR_COMPLETE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, COMPLETE_TRANSACTION: null },
                success: { ...state.success, COMPLETE_TRANSACTION: null },
                successMsg: null,
            }

        case TransactionsActionTypes.START_APPROVE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.success, APPROVE_TRANSACTION: true },
            }
        case TransactionsActionTypes.SUCCESS_APPROVE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, APPROVE_TRANSACTION: null },
                success: { ...state.success, APPROVE_TRANSACTION: true },
                successMsg: 'aproved',
            }
        case TransactionsActionTypes.FINISH_APPROVE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, APPROVE_TRANSACTION: null },
                success: { ...state.success, APPROVE_TRANSACTION: null },
                successMsg: null,
            }
        case TransactionsActionTypes.ERROR_APPROVE_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, APPROVE_TRANSACTION: null },
                success: { ...state.success, APPROVE_TRANSACTION: null },
                successMsg: null,
            }

        case TransactionsActionTypes.START_FAKE_DEPOSIT:
            return {
                ...state,
                loader: { ...state.loader, FAKE_DEPOSIT: true },
            }
        case TransactionsActionTypes.SUCCESS_FAKE_DEPOSIT:
            return {
                ...state,
                loader: { ...state.loader, FAKE_DEPOSIT: null },
                success: { ...state.success, FAKE_DEPOSIT: true },
            }
        case TransactionsActionTypes.FINISH_FAKE_DEPOSIT:
            return {
                ...state,
                loader: { ...state.loader, FAKE_DEPOSIT: null },
                success: { ...state.success, FAKE_DEPOSIT: null },
            }
        case TransactionsActionTypes.ERROR_FAKE_DEPOSIT:
            return {
                ...state,
                loader: { ...state.loader, FAKE_DEPOSIT: null },
                success: { ...state.success, FAKE_DEPOSIT: null },
            }

        case TransactionsActionTypes.START_DOWNLOAD_PDF_TRANSACTION:
            return {
                ...state,
                loader: { ...state.loader, DOWNLOAD_PDF_TRANSACTION: true },
            }
        case TransactionsActionTypes.SUCCESS_DOWNLOAD_PDF_TRANSACTION:
            return {
                ...state,
                pdfDownload: action.payload,
                loader: { ...state.loader, DOWNLOAD_PDF_TRANSACTION: null },
                success: { ...state.success, DOWNLOAD_PDF_TRANSACTION: true },
            }
        case TransactionsActionTypes.FINISH_DOWNLOAD_PDF_TRANSACTION:
            return {
                ...state,
                pdfDownload: null,
                loader: { ...state.loader, DOWNLOAD_PDF_TRANSACTION: null },
                success: { ...state.success, DOWNLOAD_PDF_TRANSACTION: null },
            }
        case TransactionsActionTypes.ERROR_DOWNLOAD_PDF_TRANSACTION:
            return {
                ...state,
                pdfDownload: null,
                loader: { ...state.loader, DOWNLOAD_PDF_TRANSACTION: null },
                success: { ...state.success, DOWNLOAD_PDF_TRANSACTION: null },
            }

        case TransactionsActionTypes.START_GET_PDF_STATEMENT:
            return {
                ...state,
                loader: { ...state.loader, GET_PDF_STATEMENT: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_PDF_STATEMENT:
            return {
                ...state,
                pdfStatement: action.payload,
                loader: { ...state.loader, GET_PDF_STATEMENT: null },
                success: { ...state.success, GET_PDF_STATEMENT: true },
            }
        case TransactionsActionTypes.FINISH_GET_PDF_STATEMENT:
            return {
                ...state,
                pdfStatement: null,
                loader: { ...state.loader, GET_PDF_STATEMENT: null },
                success: { ...state.success, GET_PDF_STATEMENT: null },
            }
        case TransactionsActionTypes.ERROR_GET_PDF_STATEMENT:
            return {
                ...state,
                pdfStatement: null,
                loader: { ...state.loader, GET_PDF_STATEMENT: null },
                success: { ...state.success, GET_PDF_STATEMENT: null },
            }

        case TransactionsActionTypes.START_GET_TXT_STATEMENT:
            return {
                ...state,
                loader: { ...state.loader, GET_TXT_STATEMENT: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_TXT_STATEMENT:
            return {
                ...state,
                textStatement: action.payload,
                loader: { ...state.loader, GET_TXT_STATEMENT: null },
                success: { ...state.success, GET_TXT_STATEMENT: true },
            }
        case TransactionsActionTypes.FINISH_GET_TXT_STATEMENT:
            return {
                ...state,
                textStatement: null,
                loader: { ...state.loader, GET_TXT_STATEMENT: null },
                success: { ...state.success, GET_TXT_STATEMENT: null },
            }
        case TransactionsActionTypes.ERROR_GET_TXT_STATEMENT:
            return {
                ...state,
                textStatement: null,
                loader: { ...state.loader, GET_TXT_STATEMENT: null },
                success: { ...state.success, GET_TXT_STATEMENT: null },
            }

        case TransactionsActionTypes.START_GET_XML_STATEMENT:
            return {
                ...state,
                loader: { ...state.loader, GET_XML_STATEMENT: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_XML_STATEMENT:
            return {
                ...state,
                xmlStatement: action.payload,
                loader: { ...state.loader, GET_XML_STATEMENT: null },
                success: { ...state.success, GET_XML_STATEMENT: true },
            }
        case TransactionsActionTypes.FINISH_GET_XML_STATEMENT:
            return {
                ...state,
                xmlStatement: null,
                loader: { ...state.loader, GET_XML_STATEMENT: null },
                success: { ...state.success, GET_XML_STATEMENT: null },
            }
        case TransactionsActionTypes.ERROR_GET_XML_STATEMENT:
            return {
                ...state,
                xmlStatement: null,
                loader: { ...state.loader, GET_XML_STATEMENT: null },
                success: { ...state.success, GET_XML_STATEMENT: null },
            }
        // CSV
        case TransactionsActionTypes.START_GET_CSV_STATEMENT:
            return {
                ...state,
                loader: { ...state.loader, GET_CSV_STATEMENT: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_CSV_STATEMENT:
            return {
                ...state,
                csvStatement: action.payload,
                loader: { ...state.loader, GET_CSV_STATEMENT: null },
                success: { ...state.success, GET_CSV_STATEMENT: true },
            }
        case TransactionsActionTypes.FINISH_GET_CSV_STATEMENT:
            return {
                ...state,
                csvStatement: null,
                loader: { ...state.loader, GET_CSV_STATEMENT: null },
                success: { ...state.success, GET_CSV_STATEMENT: null },
            }
        case TransactionsActionTypes.ERROR_GET_CSV_STATEMENT:
            return {
                ...state,
                csvStatement: null,
                loader: { ...state.loader, GET_CSV_STATEMENT: null },
                success: { ...state.success, GET_CSV_STATEMENT: null },
            }

        case TransactionsActionTypes.START_GET_FILES:
            return {
                ...state,
                loader: { ...state.loader, GET_FILES: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_FILES:
            return {
                ...state,
                files: action.payload,
                loader: { ...state.loader, GET_FILES: null },
                success: { ...state.success, GET_FILES: true },
            }
        case TransactionsActionTypes.FINISH_GET_FILES:
            return {
                ...state,
                files: null,
                loader: { ...state.loader, GET_FILES: null },
                success: { ...state.success, GET_FILES: null },
            }
        case TransactionsActionTypes.ERROR_GET_FILES:
            return {
                ...state,
                files: null,
                loader: { ...state.loader, GET_FILES: null },
                success: { ...state.success, GET_FILES: null },
            }

        case TransactionsActionTypes.START_GET_COUNTS:
            return {
                ...state,
                loader: { ...state.loader, GET_COUNTS: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_COUNTS:
            return {
                ...state,
                counts: action.payload,
                loader: { ...state.loader, GET_COUNTS: null },
                success: { ...state.success, GET_COUNTS: true },
            }
        case TransactionsActionTypes.ERROR_GET_COUNTS:
            return {
                ...state,
                counts: null,
                loader: { ...state.loader, GET_COUNTS: null },
                success: { ...state.success, GET_COUNTS: null },
            }
        case TransactionsActionTypes.FINISH_GET_COUNTS:
            return {
                ...state,
                counts: null,
                loader: { ...state.loader, GET_COUNTS: null },
                success: { ...state.success, GET_COUNTS: null },
            }

        case TransactionsActionTypes.START_GET_STATUSES:
            return {
                ...state,
                loader: { ...state.loader, GET_STATUSES: true },
            }
        case TransactionsActionTypes.SUCCESS_GET_STATUSES:
            return {
                ...state,
                statuses: action.payload,
                loader: { ...state.loader, GET_STATUSES: null },
                success: { ...state.success, GET_STATUSES: true },
            }
        case TransactionsActionTypes.ERROR_GET_STATUSES:
            return {
                ...state,
                statuses: null,
                loader: { ...state.loader, GET_STATUSES: null },
                success: { ...state.success, GET_STATUSES: null },
            }
        case TransactionsActionTypes.FINISH_GET_STATUSES:
            return {
                ...state,
                statuses: null,
                loader: { ...state.loader, GET_STATUSES: null },
                success: { ...state.success, GET_STATUSES: null },
            }

        default:
            return state
    }
}

export default transactionsReducer
